import API_CONFIG from '../config/api';

class DropdownService {
  static baseURL = `${API_CONFIG.API_BASE}/dropdowns`;

  // Get all dropdowns with pagination and filtering
  static async getDropdowns(params = {}) {
    try {
      const queryParams = new URLSearchParams();
      
      if (params.page) queryParams.append('page', params.page);
      if (params.limit) queryParams.append('limit', params.limit);
      if (params.search) queryParams.append('search', params.search);
      if (params.isSystem !== undefined) queryParams.append('isSystem', params.isSystem);
      if (params.sortBy) queryParams.append('sortBy', params.sortBy);
      if (params.sortOrder) queryParams.append('sortOrder', params.sortOrder);

      const response = await fetch(`${this.baseURL}?${queryParams}`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      return await response.json();
    } catch (error) {
      console.error('Error fetching dropdowns:', error);
      throw error;
    }
  }

  // Get dropdown by ID
  static async getDropdownById(id) {
    try {
      const response = await fetch(`${this.baseURL}/${id}`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      return await response.json();
    } catch (error) {
      console.error('Error fetching dropdown:', error);
      throw error;
    }
  }

  // Get dropdown by name
  static async getDropdownByName(name) {
    try {
      const response = await fetch(`${this.baseURL}/name/${name}`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      return await response.json();
    } catch (error) {
      console.error('Error fetching dropdown by name:', error);
      throw error;
    }
  }

  // Create new dropdown
  static async createDropdown(dropdownData) {
    try {
      const response = await fetch(this.baseURL, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(dropdownData),
      });

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.message || `HTTP error! status: ${response.status}`);
      }

      return await response.json();
    } catch (error) {
      console.error('Error creating dropdown:', error);
      throw error;
    }
  }

  // Update dropdown
  static async updateDropdown(id, dropdownData) {
    try {
      const response = await fetch(`${this.baseURL}/${id}`, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(dropdownData),
      });

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.message || `HTTP error! status: ${response.status}`);
      }

      return await response.json();
    } catch (error) {
      console.error('Error updating dropdown:', error);
      throw error;
    }
  }

  // Delete dropdown
  static async deleteDropdown(id) {
    try {
      const response = await fetch(`${this.baseURL}/${id}`, {
        method: 'DELETE',
        headers: {
          'Content-Type': 'application/json',
        },
      });

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.message || `HTTP error! status: ${response.status}`);
      }

      return await response.json();
    } catch (error) {
      console.error('Error deleting dropdown:', error);
      throw error;
    }
  }

  // Add value to dropdown
  static async addDropdownValue(dropdownId, valueData) {
    try {
      const response = await fetch(`${this.baseURL}/${dropdownId}/values`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(valueData),
      });

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.message || `HTTP error! status: ${response.status}`);
      }

      return await response.json();
    } catch (error) {
      console.error('Error adding dropdown value:', error);
      throw error;
    }
  }

  // Update dropdown value
  static async updateDropdownValue(dropdownId, valueId, valueData) {
    try {
      const response = await fetch(`${this.baseURL}/${dropdownId}/values/${valueId}`, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(valueData),
      });

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.message || `HTTP error! status: ${response.status}`);
      }

      return await response.json();
    } catch (error) {
      console.error('Error updating dropdown value:', error);
      throw error;
    }
  }

  // Delete dropdown value
  static async deleteDropdownValue(dropdownId, valueId) {
    try {
      const response = await fetch(`${this.baseURL}/${dropdownId}/values/${valueId}`, {
        method: 'DELETE',
        headers: {
          'Content-Type': 'application/json',
        },
      });

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.message || `HTTP error! status: ${response.status}`);
      }

      return await response.json();
    } catch (error) {
      console.error('Error deleting dropdown value:', error);
      throw error;
    }
  }
}

export default DropdownService;
